<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { defineProps, defineEmits, reactive, ref, onMounted, computed } from "vue";

    const emit = defineEmits(["uploaded"])
    const props = defineProps({
        id: { type: String, required: true },
        label: { type: String, default: 'Fichier' },
        type: { type: String, default: 'ALL' },
        preview: { type: String },
        size: { type: String as () => 'normal' | 'small', default: 'normal' },
    });

    const allExtensionsInfos = {
        'ALL': {
            extensions_allowed: '',
            extensions_labels: 'Tous les fichiers'
        },
        'VIDEO': {
            extensions_allowed: '.mp4,.avi,.mov,.mkv',
            extensions_labels: 'MP4, MOV, AVI, MKV'
        },
        'IMAGE': {
            extensions_allowed: '.jpg,.jpeg,.png,.gif,.webp,.svg',
            extensions_labels: 'JPG, PNG, GIF, Webp, SVG'
        },
    };
    const extensionsAllowed = ref('');
    const extensionsLabels = ref('');
    const formValue = reactive({
        file: '',
        file_name: '',
        file_preview: null as any,
    });
    const previewComponent = computed(() => formValue.file_preview ?? props.preview);

    onMounted(() => {
        extensionsAllowed.value = allExtensionsInfos[props.type as keyof typeof allExtensionsInfos].extensions_allowed;
        extensionsLabels.value = allExtensionsInfos[props.type as keyof typeof allExtensionsInfos].extensions_labels;
    });

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formValue.file = event.target.files[0];
                formValue.file_name = event.target.files[0].name;
                formValue.file_preview = e.target!.result as string;
                emit('uploaded', formValue);
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }

</script>
<style scoped>
    .super-custom-upload.small {
        width: 10rem !important;
        height: 10rem !important;
    }
    .super-custom-upload.small .super-custom-upload-inner {
        padding: 0px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .super-custom-upload.small .super-custom-upload-inner .super-custom-upload-btn {
        transform: none;
        width: 35px;
        height: 35px;
        padding: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .super-custom-upload.small .super-custom-upload-inner .super-custom-upload-btn img {
        width: 10px;
    }
</style>
<template>
    <template v-if="props.size == 'normal'">
        <label :for="props.id" class="super-custom-upload rounded-100 active" :style="{ background: `url('${previewComponent ?? ''}')`, backgroundSize: 'cover', backgroundPosition: 'center' }">
            <div class="super-custom-upload-inner">
                <h6>{{ props.label }}</h6>
                <div class="super-custom-upload-btn">
                    <input :id="props.id" class="display-none" type="file" ref="fichier_photo" @change="onFileUploaded($event)" :accept="extensionsAllowed" />
                    <img src="/icons/icon-upload.svg" class="super-custom-upload-icon" />
                </div>
                <span>{{ extensionsLabels }}</span><br/>
            </div>
        </label>
    </template>
    <template v-if="props.size == 'small'">
        <label :for="props.id" class="super-custom-upload small rounded-100 active" :style="{ background: `url('${previewComponent ?? ''}')`, backgroundSize: 'cover', backgroundPosition: 'center' }">
            <div class="super-custom-upload-inner">
                <div class="super-custom-upload-btn">
                    <input :id="props.id" class="display-none" type="file" ref="fichier_photo" @change="onFileUploaded($event)" :accept="extensionsAllowed" />
                    <img src="/icons/icon-upload.svg" class="super-custom-upload-icon" />
                </div>
                <span>{{ extensionsLabels }}</span><br/>
            </div>
        </label>
    </template>
</template>